import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  header: {
    paddingBottom: token.paddingMD
  },
  statusPill: {
    display: 'inline-flex',
    alignItems: 'center',
    height: token.controlHeightXS,
    paddingBlock: 0,
    paddingInline: token.paddingXS,
    borderRadius: token.borderRadiusLG,
    backgroundColor: token.colorFillTertiary,
    fontSize: token.fontSizeSM,
    lineHeight: 1
  },
  title: {
    margin: 0,
    fontSize: token.fontSizeHeading5,
    fontWeight: token.fontWeightStrong,
    color: token.colorText
  },
  meta: {
    color: token.colorTextTertiary,
    fontSize: token.fontSizeSM
  },
  metaValue: {
    color: token.colorTextSecondary
  },
  section: {
    paddingBlock: token.paddingMD,
    borderTop: `${token.lineWidth}px solid ${token.colorSplit}`
  },
  description: {
    margin: 0,
    whiteSpace: 'pre-wrap',
    color: token.colorText
  },
  attachmentChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: token.marginXS,
    maxWidth: token.controlHeight * 12,
    paddingBlock: token.paddingXXS,
    paddingInline: token.paddingSM,
    border: `${token.lineWidth}px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    color: token.colorText,
    '&:hover': {
      borderColor: token.colorPrimaryBorderHover,
      color: token.colorText
    },
    '&:focus-visible': {
      outline: 'none',
      boxShadow: '0 0 0 3px var(--brand-teal-soft)'
    }
  },
  attachmentName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  muted: {
    color: token.colorTextTertiary,
    fontSize: token.fontSizeSM
  },
  activityCount: {
    minWidth: token.controlHeightXS,
    paddingInline: token.paddingXXS,
    borderRadius: token.borderRadiusLG,
    backgroundColor: token.colorFillTertiary,
    color: token.colorTextSecondary,
    textAlign: 'center'
  },
  thread: {
    maxHeight: token.controlHeight * 12,
    overflowY: 'auto'
  },
  avatar: {
    flex: 'none',
    width: token.controlHeight,
    height: token.controlHeight,
    borderRadius: token.borderRadiusSM,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: token.fontSizeSM,
    color: token.colorWhite,
    backgroundColor: token.colorTextTertiary
  },
  avatarSupport: {
    backgroundColor: token.colorPrimary
  },
  messageAuthor: {
    fontWeight: token.fontWeightStrong,
    color: token.colorText
  },
  bubble: {
    alignSelf: 'flex-start',
    maxWidth: '100%',
    paddingBlock: token.paddingXS,
    paddingInline: token.paddingSM,
    borderRadius: token.borderRadiusLG,
    backgroundColor: token.colorFillTertiary,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: token.colorText
  },
  bubbleSupport: {
    backgroundColor: token.colorPrimaryBg
  },
  messageImage: {
    maxWidth: token.controlHeight * 10,
    width: '100%',
    height: 'auto',
    marginTop: token.marginXS,
    borderRadius: token.borderRadiusLG,
    border: `${token.lineWidth}px solid ${token.colorBorderSecondary}`
  },
  composer: {
    marginTop: token.marginMD
  }
}))
